const actions = {
  async listQuotation(context, payload) {
    try {
      const response = await this.$api.call(
        "finops_commission_from_insurance_transaction_detail.quoteList",
        payload,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit(
          "mutationCommissionFromInsuranceTransactionDetailQuotationList",
          {
            responseData,
            tab: payload.tab,
          },
        );
      } else {
        context.commit(
          "mutationCommissionFromInsuranceTransactionDetailQuotationList",
          responseData,
        );
      }

      context.commit(
        "mutationCommissionFromInsuranceTransactionDetailQuotationListMeta",
        response.meta,
      );

      return response;
    } catch (error) {
      context.commit(
        "mutationCommissionFromInsuranceTransactionDetailQuotationList",
        [],
      );
      context.commit(
        "mutationCommissionFromInsuranceTransactionDetailQuotationListMeta",
        {},
      );

      throw error;
    }
  },
};

export default actions;
